import { create } from "zustand";
import {
  IInsuranceCompanySchema,
  QuotesFilterState,
} from "./quotesStore.types";

const initialState = {
  selectedSort: { name: "Relevance", code: "relevance", id: 1 },
  selectedCover: null,
  selectedInsuranceCompanies: [] as IInsuranceCompanySchema[],
  layoutGrid: true,
};

export const useQuotesFilterStore = create<QuotesFilterState>((set) => ({
  ...initialState,

  setSelectedSort: (sort) => set({ selectedSort: sort }),

  setSelectedCover: (cover) => set({ selectedCover: cover }),

  setSelectedInsuranceCompanies: (ics) =>
    set({ selectedInsuranceCompanies: ics }),

  setLayoutGrid: (grid) =>
    set((state) => ({
      layoutGrid: typeof grid === "function" ? grid(state.layoutGrid) : grid,
    })),
}));
